import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHazardousActivities = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 23.529,
	height: 20,
	viewBox: "0 0 23.529 20",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_15902",
		"data-name": "Group 15902",
		transform: "translate(-91 -23)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Polygon_38",
				"data-name": "Polygon 38",
				transform: "translate(91 23)",
				fill: "none",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M10.041,2.931a2,2,0,0,1,3.448,0l8.268,14.055A2,2,0,0,1,20.033,20H3.5a2,2,0,0,1-1.724-3.014Z",
					stroke: "none"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M 11.76470565795898 3.444610595703125 C 11.65790557861328 3.444610595703125 11.45989608764648 3.476631164550781 11.33373546600342 3.69110107421875 L 3.065866470336914 17.74649047851562 C 2.937915802001953 17.9640007019043 3.009025573730469 18.15422058105469 3.06280517578125 18.24824142456055 C 3.116584777832031 18.34226226806641 3.244476318359375 18.50000190734863 3.496835708618164 18.50000190734863 L 20.0325756072998 18.50000190734863 C 20.28492546081543 18.50000190734863 20.41282653808594 18.34226226806641 20.46660614013672 18.24824142456055 C 20.5203857421875 18.15421104431152 20.59149551391602 17.9640007019043 20.46354484558105 17.74649047851562 L 12.19567584991455 3.69110107421875 C 12.06951522827148 3.476631164550781 11.87150573730469 3.444610595703125 11.76470565795898 3.444610595703125 M 11.76470565795898 1.944614410400391 C 12.43331527709961 1.944614410400391 13.10192584991455 2.273265838623047 13.48857593536377 2.930570602416992 L 21.75644493103027 16.9859619140625 C 22.54072570800781 18.3192310333252 21.57940483093262 20.00000190734863 20.0325756072998 20.00000190734863 L 3.496835708618164 20.00000190734863 C 1.949995040893555 20.00000190734863 0.9886856079101562 18.3192310333252 1.772966384887695 16.9859619140625 L 10.0408353805542 2.930570602416992 C 10.42748546600342 2.273265838623047 11.09609603881836 1.944614410400391 11.76470565795898 1.944614410400391 Z",
					stroke: "none",
					fill: "currentColor"
				})]
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_119",
				"data-name": "Line 119",
				y2: 4.706,
				transform: "translate(102.765 31.235)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_120",
				"data-name": "Line 120",
				transform: "translate(102.765 38.882)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeWidth: 1.5
			})
		]
	})
});
export default SvgHazardousActivities;
